<template>
    <div class="text-center">
        <v-dialog persistent v-model="visible" width="800">
            <v-card class="not-margin pt-0 pr-0 pl-0">
                <v-toolbar dark color="primary">
                    <div class="text-center">
                        Alterar Data Formação
                    </div>
                </v-toolbar>
                <div class="container dialog">
                <v-form ref="form" v-if="visible">
                    <v-row class="d-flex justify-center mt-2">
                        <v-col cols="12" class="d-block">
                        <label 
                            for="motivoAlteracao" 
                            style="font-weight: 500">
                            Motivo de alteração*
                        </label>
                        <v-textarea 
                            id="motivoAlteracao" 
                            v-model="form.motivoAlteracao" 
                            :counter="400"
                            maxlength="400" 
                            outlined dense 
                            :rules="[$required]" />
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-center">
                        <sigfoco-date-picker 
                            v-model="form.dataInicio" 
                            label="Nova Data Início*"
                            :dataEdicao="form.dataInicio" 
                            outlined 
                            removeIcon
                            dense 
                            :rules="[
                                (v) => !!v || 'Campo obrigatório',
                                () => validateData() || 'Selecione um intervalo de datas válido para continuar.'
                            ]" />
                        <sigfoco-date-picker 
                            v-model="form.dataFim" 
                            label="Nova Data Fim*"
                            :dataEdicao="form.dataFim"
                            outlined
                            removeIcon
                            dense 
                            :rules="[
                                (v) => !!v || 'Campo obrigatório',
                                () => validateData() || 'Selecione um intervalo de datas válido para continuar.'
                            ]"/>
                    </v-row>
                </v-form>
                </div>
                <sigfoco-buttons @click="reagendar()" @cancel="$emit('onClose')" :actionText="'Salvar'"></sigfoco-buttons>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Formacao } from '~/commons/classes/formacao';
import ManterFormacaoService from '~/services/manter-formacao.service';

export default {
    props: new DialogProps(Formacao),
    mixins: [ManterFormacaoService],
    data: () => ({
        form: {
        motivoAlteracao: '',
        dataInicio: '',
        dataFim: '',
        }
    }),
    methods: {
        reagendar() {
            if (!this.$refs.form.validate()) {
                return this.$notifyWarning("Preencha todos os campos obrigatórios!");
            }
            this.confirmacaoModal();
        },
        confirmacaoModal() {
            this.$swal({
                text: `Deseja reagendar a Solicitação de Formação?`,
                type: "error",
                showCancelButton: true,
                confirmButtonText: `Confirmar`,
                cancelButtonText: `Cancelar`,
            }).then(() => {
                this.$Reagendar(
                { 
                    formacaoId: this.content.id, 
                    motivoAlteracao: this.form.motivoAlteracao,
                    dataInicio: this.form.dataInicio,
                    dataFim: this.form.dataFim
                },
                this.content.id
                ).then(({ data }) => {
                    this.$notifySuccess(data.mensagem);
                    this.$emit('onConfirm', this.content);
                    this.$emit('onClose', this.content);
                })
            }).catch(() => {
                this.$emit('onClose', this.content);
            });
        },
        validateData() {
            if (!this.form.dataInicio || !this.form.dataFim) return true;
            const dataInicio = new Date(this.form.dataInicio);
            const dataFim = new Date(this.form.dataFim);
            return dataInicio <= dataFim;
        },
    }
};
</script>